// semeia-disable-reexport
import type Patient from "parog-web/models/patient";
import type {
  CPSInformations,
  InsIdentityResult,
  PracticeLocation
} from "parog-web/cnam/types";
import type { AuthenticationContext } from "parog-web/contexts/authentication-context";
import {
  CnamApiCpsNoBillingNumber,
  CnamApiInsBirthdayInvalidError
} from "parog-web/utils/cnam-api-errors";

export interface AdministrativeCPSInformations {
  billingNumber?: string;
  finess?: string;
  siret?: string;
}

export abstract class InsiAdapter {
  declare authenticationContext: AuthenticationContext;
  abstract retrieveInsIdentity(patient: Patient): Promise<InsIdentityResult>;

  checkBillingNumber(
    selectedPracticeLocation: PracticeLocation,
    billingNumber: string | undefined
  ): void {
    if (!billingNumber) {
      let message = `No billing informations (billing number, FINESS or SIRET) found for the practice location ${selectedPracticeLocation.structureName}.`;

      const validPracticeLocations =
        this.authenticationContext.availableLocations!.filter(
          practiceLocation => {
            const administrativeInfos =
              this.authenticationContext?.retrieveAdministrativeInformationFromPraticeLocation(
                practiceLocation
              );
            return (
              administrativeInfos.billingNumber ||
              administrativeInfos.finess ||
              administrativeInfos.siret
            );
          }
        );
      if (validPracticeLocations?.length > 0) {
        message += ` Please select another practice location among : ${validPracticeLocations
          ?.map(p => p.structureName)
          .join(", ")}`;
      } else {
        message += ` There is no other practice location with billing informations. You can't retrieve an INS with this CPS card.`;
      }
      throw new CnamApiCpsNoBillingNumber(message);
    }
  }

  retrieveBillingNumber(): string {
    const cpsCard = this.authenticationContext
      .cpsInformations as CPSInformations;

    const selectedPracticeLocation =
      cpsCard.practiceLocations[
        this.authenticationContext.cpsPracticeLocationIndice!
      ];

    const billingNumber = this.authenticationContext?.billingNumber;

    this.checkBillingNumber(selectedPracticeLocation, billingNumber);

    return billingNumber as string;
  }

  checkBirthday(birthday: string | undefined): void {
    if (!birthday) return;
    const month = birthday.substring(4, 6);
    const day = birthday.substring(6, 8);

    if (month == "00" || day == "00") {
      throw new CnamApiInsBirthdayInvalidError();
    }
  }
}
